import { Path, Svg } from './styles';
import { IconProps } from './types';

const path = [
  'M6.41699 1.83594V13.5026C3.45949 13.2109 1.16699 10.7084 1.16699',
  '7.66927C1.16699 4.6301 3.45949 2.1276 6.41699 1.83594ZM7.60116',
  '1.83594V7.0801H12.8337C12.5595 4.3151 10.3603 2.1101 7.60116 1.83594ZM7.60116',
  '8.25844V13.5026C10.3662 13.2284 12.5595 11.0234 12.8337 8.25844H7.60116Z',
].join(' ');

export const IconPieChart = ({ width = 14, height = 14, color, className }: IconProps) => (
  <Svg className={className} width={width} height={height} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <Path d={path} fill={color} />
  </Svg>
);

export default IconPieChart;
